export enum FilterTypes {
  UserId = 'UserId',
  UserProperty = 'UserProperty',
  UserEmail = 'UserEmail',
  ContentId = 'ContentId',
  SegmentId = 'SegmentId',
  Host = 'Host',
  Pathname = 'Pathname',
}

export const FilterEnglishNames = {
  [FilterTypes.UserId]: 'User Id',
  [FilterTypes.UserEmail]: 'User Email',
  [FilterTypes.UserProperty]: 'User Property',
  [FilterTypes.ContentId]: 'Content',
  [FilterTypes.SegmentId]: 'Segment',
  [FilterTypes.Host]: 'URL Domain',
  [FilterTypes.Pathname]: 'URL Path',
};

export enum FilterOperations {
  Equals = '=',
  EqualsNot = '<>',
  Contains = 'like',
  ContainsNot = 'likeNot',
  GreaterThan = '>',
  SmallerThan = '<',
  OneOf = 'in',
  NotOneOf = 'notIn',
}

export const FilterOperationsEnglishNames = {
  [FilterOperations.Equals]: 'Equals',
  [FilterOperations.EqualsNot]: 'Does not equal',
  [FilterOperations.OneOf]: 'Is one of',
  [FilterOperations.NotOneOf]: 'Is not one of',
  [FilterOperations.Contains]: 'Contains',
  [FilterOperations.ContainsNot]: 'Does not contain',
  [FilterOperations.GreaterThan]: 'Greater Than',
  [FilterOperations.SmallerThan]: 'Smaller Than',
};

export interface UserPropertyFilter {
  id: string;
  type: FilterTypes.UserProperty;
  traitName: string;
  traitType?: string;
  operation: {
    type: FilterOperations;
    operand: string;
  };
}

export interface GenericFilter {
  id: string;
  type: FilterTypes;
  operation: {
    type: FilterOperations;
    operand: string;
  };
}

export type Filter = UserPropertyFilter | GenericFilter;

export const defaultFilterOptions = Object.values(FilterTypes);

export const userFilterOptions = [
  FilterTypes.UserId,
  FilterTypes.UserEmail,
  FilterTypes.UserProperty,
];

// you can't filter by content inside a content...
export const contentFilterOptions = Object.values(FilterTypes).filter(
  (f) => f !== FilterTypes.ContentId,
);
